import { render, staticRenderFns } from "./permissionTable.vue?vue&type=template&id=01c4a124&scoped=true&"
import script from "./permissionTable.vue?vue&type=script&lang=ts&"
export * from "./permissionTable.vue?vue&type=script&lang=ts&"
import style0 from "./permissionTable.vue?vue&type=style&index=0&id=01c4a124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c4a124",
  null
  
)

export default component.exports